export const regionList = {
  us: {
    type: 'State',
    items: [
      'Alabama',
      'Alaska',
      'American Samoa',
      'Arizona',
      'Arkansas',
      'California',
      'Colorado',
      'Connecticut',
      'Delaware',
      'District of Columbia',
      'Florida',
      'Georgia',
      'Guam',
      'Hawaii',
      'Idaho',
      'Illinois',
      'Indiana',
      'Iowa',
      'Kansas',
      'Kentucky',
      'Louisiana',
      'Maine',
      'Maryland',
      'Massachusetts',
      'Michigan',
      'Minnesota',
      'Mississippi',
      'Missouri',
      'Montana',
      'Nebraska',
      'Nevada',
      'New Hampshire',
      'New Jersey',
      'New Mexico',
      'New York',
      'North Carolina',
      'North Dakota',
      'Ohio',
      'Oklahoma',
      'Oregon',
      'Palau',
      'Pennsylvania',
      'Puerto Rico',
      'Rhode Island',
      'South Carolina',
      'South Dakota',
      'Tennessee',
      'Texas',
      'Utah',
      'Vermont',
      'Virgin Island',
      'Virginia',
      'Washington',
      'West Virginia',
      'Wisconsin',
      'Wyoming'
    ]
  },
  au: {
    type: 'State or territory',
    items: [
      'Australian Capital Territory',
      'New South Wales',
      'Northern Territory',
      'Queensland',
      'South Australia',
      'Tasmania',
      'Victoria',
      'Western Australia'
    ]
  },
  ca: {
    type: 'Province',
    items: [
      'Alberta',
      'British Columbia',
      'Manitoba',
      'New Brunswick',
      'Newfoundland and Labrador',
      'Nova Scotia',
      'Ontario',
      'Prince Edward Island',
      'Quebec',
      'Saskatchewan'
    ]
  },

  gb: {
    type: 'County',
    items: [
      'Aberdeenshire',
      'Angus',
      'Antrim',
      'Argyll',
      'Armagh',
      'Avon',
      'Ayrshire',
      'Banffshire',
      'Bedfordshire',
      'Berkshire',
      'Berwickshire',
      'Buckinghamshire',
      'Bute',
      'Caithness',
      'Cambridgeshire',
      'Cheshire',
      'Clackmannanshire',
      'Cleveland',
      'Clwyd',
      'Cornwall',
      'Cumbria',
      'Derbyshire',
      'Devon',
      'Dorset',
      'Down',
      'Dumfriesshire',
      'Dunbartonshire',
      'Durham',
      'Dyfed',
      'East Lothian',
      'East Sussex',
      'Essex',
      'Fermanagh',
      'Fife',
      'Gloucestershire',
      'Gwent',
      'Gwynedd',
      'Hampshire',
      'Herefordshire',
      'Hertfordshire',
      'Inverness-shire',
      'Isle of Wight',
      'Kent',
      'Kincardineshire',
      'Kinross-shire',
      'Kirkcudbrightshire',
      'Lanarkshire',
      'Lancashire',
      'Leicestershire',
      'Lincolnshire',
      'London',
      'Londonderry',
      'Merseyside',
      'Mid Glamorgan',
      'Middlesex',
      'Midlothian',
      'Moray',
      'Nairnshire',
      'Norfolk',
      'North Humberside',
      'North Yorkshire',
      'Northamptonshire',
      'Northumberland',
      'Nottinghamshire',
      'Orkney',
      'Oxfordshire',
      'Peeblesshire',
      'Perthshire',
      'Powys',
      'Renfrewshire',
      'Ross-shire',
      'Roxburghshire',
      'Rutland',
      'Selkirkshire',
      'Shetland',
      'Shropshire',
      'Somerset',
      'South Glamorgan',
      'South Humberside',
      'South Yorkshire',
      'Staffordshire',
      'Stirlingshire',
      'Suffolk',
      'Surrey',
      'Sutherland',
      'Tyne and Wear',
      'Tyrone',
      'Warwickshire',
      'West Glamorgan',
      'West Lothian',
      'West Midlands',
      'West Sussex',
      'West Yorkshire',
      'Wigtownshire',
      'Wiltshire',
      'Worcestershire'
    ]
  }
} as const

export const regionNames = [
  'Alabama',
  'Alaska',
  'American Samoa',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'District of Columbia',
  'Florida',
  'Georgia',
  'Guam',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Palau',
  'Pennsylvania',
  'Puerto Rico',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virgin Island',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
  'Australian Capital Territory',
  'New South Wales',
  'Northern Territory',
  'Queensland',
  'South Australia',
  'Tasmania',
  'Victoria',
  'Western Australia',
  'Alberta',
  'British Columbia',
  'Manitoba',
  'New Brunswick',
  'Newfoundland and Labrador',
  'Nova Scotia',
  'Ontario',
  'Prince Edward Island',
  'Quebec',
  'Saskatchewan',
  'Aberdeenshire',
  'Angus',
  'Antrim',
  'Argyll',
  'Armagh',
  'Avon',
  'Ayrshire',
  'Banffshire',
  'Bedfordshire',
  'Berkshire',
  'Berwickshire',
  'Buckinghamshire',
  'Bute',
  'Caithness',
  'Cambridgeshire',
  'Cheshire',
  'Clackmannanshire',
  'Cleveland',
  'Clwyd',
  'Cornwall',
  'Cumbria',
  'Derbyshire',
  'Devon',
  'Dorset',
  'Down',
  'Dumfriesshire',
  'Dunbartonshire',
  'Durham',
  'Dyfed',
  'East Lothian',
  'East Sussex',
  'Essex',
  'Fermanagh',
  'Fife',
  'Gloucestershire',
  'Gwent',
  'Gwynedd',
  'Hampshire',
  'Herefordshire',
  'Hertfordshire',
  'Inverness-shire',
  'Isle of Wight',
  'Kent',
  'Kincardineshire',
  'Kinross-shire',
  'Kirkcudbrightshire',
  'Lanarkshire',
  'Lancashire',
  'Leicestershire',
  'Lincolnshire',
  'London',
  'Londonderry',
  'Merseyside',
  'Mid Glamorgan',
  'Middlesex',
  'Midlothian',
  'Moray',
  'Nairnshire',
  'Norfolk',
  'North Humberside',
  'North Yorkshire',
  'Northamptonshire',
  'Northumberland',
  'Nottinghamshire',
  'Orkney',
  'Oxfordshire',
  'Peeblesshire',
  'Perthshire',
  'Powys',
  'Renfrewshire',
  'Ross-shire',
  'Roxburghshire',
  'Rutland',
  'Selkirkshire',
  'Shetland',
  'Shropshire',
  'Somerset',
  'South Glamorgan',
  'South Humberside',
  'South Yorkshire',
  'Staffordshire',
  'Stirlingshire',
  'Suffolk',
  'Surrey',
  'Sutherland',
  'Tyne and Wear',
  'Tyrone',
  'Warwickshire',
  'West Glamorgan',
  'West Lothian',
  'West Midlands',
  'West Sussex',
  'West Yorkshire',
  'Wigtownshire',
  'Wiltshire',
  'Worcestershire'
] as const

export const countryCodesWithRegionNames = ['us', 'au', 'ca', 'gb']

export type RegionCode = keyof typeof regionList
export type RegionName = typeof regionNames[number]
